__turbopack_context__.v({
  "cards": "HeroCards-module__qbZGpW__cards",
});
